var render = function render(){var _vm=this,_c=_vm._self._c;return _c('code',{directives:[{name:"clean-tooltip",rawName:"v-clean-tooltip",value:(_vm.tooltip),expression:"tooltip"}],staticClass:"copy",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.clicked.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }